import { setTerm } from '@/packages/JsonQuery/helpers';

export const setBbox = setTerm('bbox');
